<template>
    <div>
        <!-- <headerNav :title="title" /> -->
        <!-- <div style="background-color:#fff;padding-top:10px;">
             <imageAd  :carouselList="carouselList"></imageAd>
        </div> -->
        <div style="background-color:#fff;">
            <van-swipe :autoplay="3000">
                <van-swipe-item v-for="(image, index) in carouselList" :key="index">
                     <div @click="nav(image.linkPath)">
                        <img v-lazy="$baseurl + image.picPath" style="width:100%"/>
                     </div>
                </van-swipe-item>
            </van-swipe>
        </div>
        
        <div class="fmain">
            <van-list
                    v-model="queryparams.loaded"
                    :finished="queryparams.loadingType=='nomore'?true:false"
                    :finished-text="queryparams.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                    @load="loaddata">
                <div class="fcontent" @click="goto('/mproductdetail',item)"  v-for="(item,index) in vlist" :key="index">
                    <div class="ftit">
                        <span class="ftit-big">{{item.title}}</span>
                        <span class="ftit-small">{{item.fTitle}}</span>
                    </div>
                    <div class="fimg" v-if="item.listPicPath">
                        <div class="fimg-dw">
                            <img :src="$baseurl+item.listPicPath"/>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <retailfooter></retailfooter>
    </div>
</template>
<script>
import Util from "@/config/Util";
import imageAd from "@/components/page/imageAd.vue";
export default {
    components:{
        [imageAd.name]:imageAd,
    },
    data(){
        return {
            queryparams:{
                loaded:false,
                loadingType: 'more',
                name:"",
                sku:"",
                ProductType:undefined,
                productSku: "",
                sorting: " sorter desc,id desc",
                maxResultCount: 6,
                skipCount: 0,
                filterindex:0,
                categoryId:0,
                isIntegral:false
            },
            refreshing:false,
            vlist:
            [
               
            ],
            title:'首页',
            carouselList:[]
        }
    },
    created(){
        
         this.getCarouseList();

         this.loaddata();
    },
    methods:{
        getCarouseList()
        {
            let carouselrequest = {
                carouselType: 0,
                sorting: " sorter desc",
                maxResultCount: 5,
                skipCount: 0,
                showType:1
            };
            //拉取轮播图
            this.ajax.post("/api/services/app/PhoneCom/QueryCarouseList", carouselrequest).then((req) => {
                this.carouselList= req.result.items;
            })

        },
        goto(url,item)
        {
            this.$router.push({path:url,query:{id:item.id}});
        },
        onRefresh()
        {
            this.loaddata('refresh');
        },
        loaddata(source)
        {
            if (this.queryparams.loadingType === 'loading' || this.queryparams.loadingType === 'nomore') {
                //防止重复加载
                if(source != 'refresh')
                {
                    return;
                } 
            }
            if (source == 'refresh') {
                this.vlist = [];
                this.queryparams.skipCount = 0;
            }
            this.queryparams.loadingType = 'loading';
            this.ajax.post('/api/services/app/PhoneCom/QueryTopList', this.queryparams).then(x => {
                this.queryparams.skipCount += this.queryparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.vlist = this.vlist.concat(x.result.items);
                console.log(this.vlist);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.queryparams.loadingType = totalcount > (this.queryparams.skipCount) ? 'more' :'nomore';
            }).finally(()=>
            {
                    this.queryparams.loaded=false;
                    this.refreshing=false;
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.fmain{
    padding: 10px 15px;
    background-color: #fff;
    font-size: 12px;
}
.fcontent{
    margin-bottom: 20px;
}
.fcontent:last-child{
    margin-bottom:0;
}
.ftit-big{
    font-size: 14px;
    margin-right: 5px;
    font-weight: bold;
}
.ftit-small{
    color:#a6a6a6;
}
.fimg-dw{
   margin-top:10px;
   position:relative;
}
.fimg-dw img{
    width: 100%;
    height: auto;
}

.fimg-content{
    position: absolute;
    left:20px;
    top:50%;
    transform: translate(0,-50%);
}
.fimg-content{
    width: 120px;
}
.fimg-content-wz{
     color:#a6a6a6;
}

</style>